import { render, staticRenderFns } from "./DocsShow.vue?vue&type=template&id=6cf5319a&scoped=true"
import script from "./DocsShow.vue?vue&type=script&lang=js"
export * from "./DocsShow.vue?vue&type=script&lang=js"
import style0 from "./DocsShow.vue?vue&type=style&index=0&id=6cf5319a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf5319a",
  null
  
)

export default component.exports